export default __webpack_public_path__ + "static/nursing_carousel_3-a367ee214107c1df1e08ec690d68fedc.jpg";